import React from 'react';
import { Button, Typography } from '@mui/material';
import { ErrorMessage } from '../error-message.component';

export const ErrorBoundary: React.FC = () => {
  return (
    <ErrorMessage>
      <Typography variant='h2'>Oops! Something went wrong.</Typography>
      <Typography>{"We're sorry, an unexpected error has occurred."}</Typography>
      <Button
        onClick={(): void => {
          window.location.reload();
        }}
      >
        Refresh
      </Button>
    </ErrorMessage>
  );
};
